const BASE_URL = "https://restaurante.altivaweb.com/BACK/public";
/*"http://localhost:8000";*/

export const API_CONFIG = {
  API_BASE_URL: `${BASE_URL}/api`,
  STORAGE_BASE_URL: BASE_URL,
};

// Para invalidaciones - usar la ruta de API para descarga
export const getStorageUrl = (path, type = 'pdf') => {
  if (!path) return null;
  
  if (path.startsWith('https://') || path.startsWith('http://')) {
    return path;
  }
  
  if (path.includes('invalidaciones') || path.includes('anulaciones')) {
    const filename = path.split('/').pop();
    return `${BASE_URL}/api/invoices/invalidacion/download/${filename}`;
  }
  
  // ✅ CAMBIO: usar API en lugar de storage directo
  const filename = path.split('/').pop(); // extrae el nombre del archivo
  const ext = filename.split('.').pop(); // extrae pdf o json
  const codigo = filename.replace(`.${ext}`, ''); // extrae el codigo_generacion
  
  return `${BASE_URL}/factura/${codigo}/${ext}`;
};

// ✅ NUEVA FUNCIÓN: Para generar URLs de descarga de facturas por código de generación
export const getInvoiceDownloadUrl = (codigoGeneracion, type = 'pdf') => {
  if (!codigoGeneracion) return null;
  return `${BASE_URL}/factura/${codigoGeneracion}/${type}`;
};

export default API_CONFIG;